import React from 'react';
import { TextArea } from '@beisen/chaos-ui';
import * as html from '../../util/html';
import transLoader from '@beisen/i18n-translation-loader';

const defaultTranslation = {
    inputHolder: '点击填写',
    required: '必填',
    inputLeastTip: '至少输入$count个字'
};
class TextAreaCompoent extends React.Component {
    constructor(props) {
        super(props);
        this.handleTouch = this.handleTouch.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.handleFocus = this.handleFocus.bind(this);
        this.state = {
            inputValue: html.decode(this.props.text || '')
        };
        this.translation = Object.assign({}, defaultTranslation, transLoader({
            inputHolder: 'fieldPlaceHolder.inputHolder',
            required: 'common.required',
            inputLeastTip: 'fieldPlaceHolder.inputLeastTip'
        }), props.translation);
    }

    handleTouch(e) {
        e && e.stopPropagation && e.stopPropagation();
    }

    handleChange(e) {
        this.setState({ inputValue: e.target.value });
    }

    handleBlur(e) {
        if(this.props.isReadOnly) return;
        let text = html.encode(this.state.inputValue.trim());
        let value = text;
        this.setState({ inputValue: value });
        if(this.props.onBlur) {
            this.props.onBlur({ text, value });
        }
    }

    handleFocus(e) {
        if(this.props.isReadOnly) return;
        if(this.props.onFocus) {
            this.props.onFocus(e);
        }
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.hasOwnProperty('text') && (nextProps.text != this.props.text || nextProps.value != this.props.value)) {
            this.setState({ inputValue: html.decode(nextProps.text || '') });
        }
    }

    render() {
        const { validators = {}, errorMessage = {} } = this.props;
        const { length = {} } = validators || {};
        const { maximum: maxCount, minimum: minCount } = length || {};
        const errMsg = (errorMessage || { }).message;
        return (<TextArea
                        handleTapContainer={this.handleTouch}
                        value={html.decode(this.state.inputValue || '')}
                        label={this.props.label}
                        type='text'
                        isReadOnly={this.props.isReadOnly}
                        errorMsg={errMsg}
                        onChange={this.handleChange}
                        formContent={this.props.text}
                        onFocus={this.handleFocus}
                        onBlur={this.handleBlur}
                        required={this.props.required}
                        maxCount={maxCount}
                        minCount={minCount}
                        desc={this.props.cmp_data.desc}
                        placeholder={this.props.cmp_data.promptmessage}
                        translation={this.translation}
                    />
           );
    }
}

TextAreaCompoent.defaultProps = {
   cmp_data: {}
};
export default TextAreaCompoent;



// WEBPACK FOOTER //
// ./src/components/Field_Components/TextAreaCompoent/TextAreaCompoent.js